import { sqliteTable, text, integer, uniqueIndex, index } from "drizzle-orm/sqlite-core";
import { aiAgents } from "./ai-agents";

// ============================================================================
// ai_agent_children — Links orchestrator agents to their sub-agents
// ============================================================================
export const aiAgentChildren = sqliteTable(
  "ai_agent_children",
  {
    id: text("id").primaryKey(), // ULID
    parentAgentId: text("parent_agent_id")
      .notNull()
      .references(() => aiAgents.id),
    childAgentId: text("child_agent_id")
      .notNull()
      .references(() => aiAgents.id),
    routingHint: text("routing_hint"), // e.g. "sales inquiries, pricing, bookings"
    sortOrder: integer("sort_order").default(0),
    isEnabled: integer("is_enabled").default(1),
    // Audit fields
    createdAt: text("created_at").notNull(),
    createdBy: text("created_by"),
  },
  (table) => [
    index("idx_ai_agent_children_parent").on(table.parentAgentId),
    uniqueIndex("idx_ai_agent_children_unique").on(table.parentAgentId, table.childAgentId),
  ]
);

export type AiAgentChild = typeof aiAgentChildren.$inferSelect;
export type NewAiAgentChild = typeof aiAgentChildren.$inferInsert;
